const USERS_KEYS = {
  USERS_SUPER_USER_PAGINATED: (params = {}) => ['users', 'super-user', 'paginated', params],
  IMPERSONATION_USERS: (params = {}) => ['users', 'impersonation', params],
};

export default USERS_KEYS;
